<template>
  <dropdown v-model="selected" label="Roční obrat vašeho e-shopu" :errors="errors" :data="data"></dropdown>
</template>

<script>
import Dropdown from "../Atomic/Dropdown.vue";

const data = [
  {
    id: "0-1-mil",
    name: "0 - 1 mil. Kč",
  },
  {
    id: "1-10-mil",
    name: "1 - 10 mil. Kč",
  },
  {
    id: "10-50-mil",
    name: "10 - 50 mil. Kč",
  },
  {
    id: "50-250-mil",
    name: "50 - 250 mil. Kč",
  },
  {
    id: "vice-nez-250-mil",
    name: "více než 250 mil. Kč",
  },
  {
    id: "nevim",
    name: "nevím",
  },
  {
    id: "nechci-uvadet",
    name: "nechci uvádět",
  },


];

export default {
  components: {
    Dropdown,
  },

  props: {
    modelValue: Object,
    errors: {
      type: Array,
      default: () => []
    }
  },

  emits: ["update:modelValue"],

  data() {
    return {
      data: data,
      defaultOption: {
        id: "non-selected",
        name: "Jaký je roční obrat vašeho e-shopu"
      }
    };
  },
  computed: {
    selected: {
      get() {
        return this.modelValue || this.defaultOption;
      },

      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
};
</script>

<style>
</style>
